'use strict';

window.addEventListener('DOMContentLoaded', () => {
  //ナビゲーションの要素を全て取得
  const navItems = document.querySelectorAll(
    '.commonPageNavListItem'
  ) as NodeListOf<HTMLAnchorElement>;

  navItems.forEach((navItem) => {
    // navItemの子要素のaタグのhrefの値を取得
    const href = navItem.querySelector('a')?.getAttribute('href');
    // 取得してきたhrefの値が#から始まる場合その#を削除する
    const id = href ? href.replace('#', '') : '';
    // そのidを持つ要素を取得し、その要素が存在しなければ自信をdisplay:noneにする
    const target = document.getElementById(id);
    if (!target) {
      navItem.style.display = 'none';
    }
  });
});
